import type { ComponentProps, ReactNode } from 'react'
import { cn } from '@/lib/cn'

export type InputProps = ComponentProps<'input'>

/**
 * A one-line text field, sized and bordered like `Button` so a settings row
 * holding one lines up with the rows holding controls.
 *
 * Autocomplete, autocorrect and spellcheck are off by default: every value this
 * app asks for — an endpoint, a token, a device name — is one a browser's
 * suggestions can only get wrong, and a token has no business in an autofill
 * store.
 */
export function Input({ className, type = 'text', ...props }: InputProps): ReactNode {
  return (
    <input
      type={type}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      className={cn(
        'h-[26px] rounded-md border border-border bg-surface px-2 text-[12px] leading-none text-fg',
        'placeholder:text-fg-faint focus:border-accent focus:outline-none',
        'disabled:pointer-events-none disabled:opacity-45',
        className,
      )}
      {...props}
    />
  )
}
